import { Transition, Disclosure } from '@headlessui/react'
import Image from 'next/image';

export function CheckMark() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="text-orange-600 w-4 h-4 flex-none mr-3">
      <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 4.5l7.5 7.5-7.5 7.5m-6-15l7.5 7.5-7.5 7.5" />
    </svg>
  );
}

export default function Faq() {
  return (
    <section className="relative bg-white bg-center overflow-hidden font-['Inter']">
      <div className="bg-transparent">
        <div className="relative pt-16 pb-12">
          <div className="container px-4 md:px-0 mx-auto max-w-3xl lg:max-w-5xl">
            <div className="relative flex flex-wrap justify-center -mx-4">
              <div className="w-full px-4 mb-12 md:mb-0 text-center">
                <h1
                  className="main-top-title mb-16">
                  Frequently Asked Questions<br />
                </h1>
                <div>
                  <div className="w-full px-10">
                    <div className="flex flex-col md:items-left items-center justify-center text-left">
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">What features do we get out of the box when you install CKAN?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">CKAN itself is a fully-featured data management platform. Out of the box, one gets user management, dataset management, search and discovery over metadata, metadata customization, data storage, a data API, and more (for example tools to integrate source data into the CKAN catalog). Additionally, CKAN has a rich ecosystem of over a hundred extensions that can be used to further customize the platform. <br /><br />
                                      Beyond the standard features available out-of-the-box, CKAN allows for a wide range of custom features to be added to the platform, including custom data visualizations, workflow automation, advanced security features, integration with other tools and services, custom metadata fields, multilingual support, and more. This flexibility enables organizations to tailor CKAN to meet their specific needs and requirements, making it an ideal choice for a variety of use cases, including open data portals, internal data management, research data management, etc.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">What custom features can we get?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'}alt="Dropdown Arrow" />
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">CKAN has a plugin-based architecture that allows for a wide range of custom features to be added as needed. This means that the platform can be tailored to meet specific needs and requirements, beyond the standard features available out of the box. Some examples of custom features that can be added to CKAN include:<br /><br />
                                      <div className="flex items-start pb-5">
                                        <div className="pt-1"><CheckMark /></div>
                                        Custom data visualizations: CKAN can be extended to include custom data visualizations, allowing users to view and interact with data in unique and innovative ways.
                                      </div>
                                      <div className="flex items-start pb-5">
                                        <div className="pt-1"><CheckMark /></div>
                                        Workflow automation: CKAN can be customized to automate specific workflows, such as data ingestion, cleaning, and transformation.
                                      </div>
                                      <div className="flex items-start pb-5">
                                        <div className="pt-1"><CheckMark /></div>
                                        Advanced security features: CKAN can be customized to include advanced security features, such as encryption and role-based access control, to protect sensitive data and ensure compliance with industry regulations.
                                      </div>
                                      <div className="flex items-start pb-5"><
                                        div className="pt-1"><CheckMark /></div>
                                        Integration with other tools and services: CKAN can be customized to integrate with other tools and services, such as data analytics platforms, content management systems, and collaboration tools.
                                      </div>
                                      <div className="flex items-start pb-5">
                                        <div className="pt-1"><CheckMark /></div>
                                        Custom metadata fields: CKAN can be customized to include custom metadata fields, allowing organizations to add specific information to their datasets that is relevant to their needs.
                                      </div>
                                      <div className="flex items-start pb-5">
                                        <div className="pt-1"><CheckMark /></div>
                                        Multilingual support: CKAN can be customized to support multiple languages, enabling organizations to reach a wider audience and improve accessibility for users in different regions.
                                      </div>

                                      CKAN&apos;s flexibility enables organizations to tailor CKAN to meet their specific needs and requirements, resulting in a more effective and efficient data management solution.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">Can CKAN be easily integrated with existing systems and tools that are being used on a company level? </h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'}alt="Dropdown Arrow" />
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">Yes, CKAN has a flexible architecture and a range of integration options that make it easy to connect with other systems and tools. It is an API-first approach and can be integrated with any tool or system as long as an API is provided.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">What is the difference between CKAN and CKAN Enterprise?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">
                                      While CKAN is an open source platform that provides a robust set of features for managing and publishing data, CKAN Enterprise provides additional enterprise-level features and support services.<br /><br />
                                      The core CKAN platform provides a robust set of features for managing and publishing data, including user management, dataset management, search and discovery capabilities, metadata customization, data storage, and a data API. CKAN is a popular choice for organizations looking to build open data portals or manage data internally.<br /><br />
                                      CKAN Enterprise builds upon the core CKAN platform, providing additional features and services that are designed to meet the needs of enterprise-level organizations. These features include advanced security and access control, data visualization tools, custom branding, and additional integrations with other enterprise-level software solutions.<br /><br />
                                      CKAN Enterprise also provides enterprise-level support and services, such as dedicated technical support, training, and consulting services. This support ensures that organizations have the resources they need to successfully implement and use CKAN within their enterprise environment.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">Can CKAN be also used for internal data management?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">
                                      Yes, CKAN can be used for internal data management. In fact, one of the common use cases for CKAN is managing data within an organization.<br /><br />
                                      CKAN also provides robust security features, including role-based access control and fine-grained permissions, that enable organizations to control who has access to sensitive data. Additionally, CKAN&apos;s flexible architecture allows it to be customized to meet specific internal data management needs, such as workflow automation and integration with other tools and systems.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
